import { gallery, h, img, link, p } from '@/content/blocks'
import type { Project } from '@/types/content'

const project: Project = {
  slug: 'frc-2020-infinite-recharge',
  title: 'FRC 2020 — Infinite Recharge',
  summary: 'FRC 1325 competition robot — Casper.',
  cover: {
    src: '/assets/FRC-InfiniteRecharge.png',
    alt: 'FRC 1325 competition robot Casper',
  },
  tags: ['CAD', 'Manufacturing'],
  order: 9,
  blocks: [
    p('In 2020, I had my first exposure to a real sense of engineering practices outside of what school taught by participating in FRC. I learned about the iterative engineering design process as the team progressed throughout competition season.'),

    p([
      'The Infinite Recharge game involves two alliances of three teams each, with each team controlling a robot and performing specific tasks on a field to score points. The game centers around a futuristic city theme involving two alliances consisting of three teams each competing to perform various tasks, including shooting foam balls known as Power Cells into high and low goals to activate a Shield Generator, manipulating a Control Panel to activate this shield, and returning to the Shield Generator to park or climb at the end of the match. The objective is to energize and activate the shield before the match ends and asteroids strike FIRST City, a futuristic city modeled after Star Wars. ',
      link('[1]', 'https://en.wikipedia.org/wiki/Infinite_Recharge#:~:text=The%20Infinite%20Recharge%20game%20involves,a%20field%20to%20score%20points.'),
    ]),

    p('The team split the mechanical design into a set of several subsystems: drivetrain, climber, intake, feeder, panel spinner, and the shooter.'),

    h('Manufacturing'),
    p('Of all the skillsets that I had acquired over the competition season, I gained the most practical experience during our build season. I manufactured components from the shooter, drivetrain, elevator, intake system, and more. I used tools range from jigsaws, riveting tools, sheet metal benders, drill press, and etc. I manufactured components both for the practice robot and competition robot which helped develop my sense for creating parts from drawings and assembling parts in context to a larger assembly.'),
    gallery([
      {
        src: '/assets/FRC1325-PracticeBot.jpg',
        alt: 'The practice robot assembled on the shop floor during build season',
        maxWidth: '60%',
      },
      {
        src: '/assets/FRC1325-RedesignedIntake.jpg',
        alt: 'The redesigned intake mechanism mounted on the robot',
        maxWidth: '60%',
      },
    ]),

    h('Subsystem'),
    p('During the design process I was able to work on a few components of the feeder subsystem. The objective of the feeder is to receive the objective (power cells) from the intake and transport it to the shooter element. This subsystem uses timing belt pulleys to pull the ball upwards and since the ball is compliant, additional compression was accounted for in order to transport the ball flawlessly each time.'),
    img('/assets/FRC1325-Feeder.png', 'CAD model of the feeder subsystem, with timing belt pulleys that carry a power cell upward from the intake to the shooter'),
  ],
}

export default project
